export default __webpack_public_path__ + "static/media/DASHPORT_white_horizontal.f1d25acc.png";